import { useEffect, useState } from "react";
import { FormCustomers } from "../components/FormCustomers";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate, useParams } from "react-router-dom";
import { ICustomer } from "../../../@types/customer.type";
import { toast } from "react-toastify";
import { getCustomerById } from "../../../services/api/customers/CustomersService";
import { FeatureStatic } from "../../../@types/statics/feature.static";
import usePermission from "../../../hooks/usePermission";
import { includeCustomFieldsfromApi } from "../adapters/customersCustomFields";
import styles from "./styles.module.scss";

export const UpdateCustomer: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [customer, setCustomer] = useState({} as ICustomer);
  const { id } = useParams();
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.clients.id);

  async function fetchCustomerById() {
    try {
      setLoading(true);

      if (!id) {
        toast.error("ID do projeto não fornecido!");
        navigate("/*");
        return;
      }

      const response = await getCustomerById(id);

      if (!response.result) {
        toast.error("Cliente não encontrado!");
        navigate("/*");
        return;
      }

      setCustomer(includeCustomFieldsfromApi(response.result));
    } catch (error) {
      console.log(error);
      toast.error("Erro ao carregar o Cliente!");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }
    fetchCustomerById();
  }, [id]);

  return (
    <>
      {loading ? (
        <CircularProgress
          size={100}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      ) : (
        <div className={styles.updateCustomer}>
          <FormCustomers pageType="update" customerData={customer} />
        </div>
      )}
    </>
  );
};
